import { HasFieldLength, HasFieldDimensions, HasLength } from '../fields';

export type FieldsContainer<T> = {
  fields: T[];
  end: number;
};
export const asFieldsWithDimensionsContainer = <T extends HasFieldLength>(
  inputFields: T[],
  delimiterLength = 0,
): FieldsContainer<HasFieldDimensions<T>> => {
  return inputFields.reduce<FieldsContainer<HasFieldDimensions<T>>>(
    (acc, current, index, source) => {
      const begin = acc.end + 1 + (index === 0 ? 0 : delimiterLength);
      const end = begin + Number(source[index]?.fieldLength || 0) - 1;
      const newAcc = {
        fields: acc.fields.concat([
          {
            ...current,
            begin,
            end,
          },
        ]),
        end,
      };
      return newAcc;
    },
    {
      fields: [] as HasFieldDimensions<T>[],
      end: 0,
    },
  );
};

export const asFieldsWithDimensionsContainerAscendArichives = <
  T extends HasLength,
>(
  inputFields: T[],
  delimiterLength = 0,
): FieldsContainer<HasFieldDimensions<T>> => {
  return inputFields.reduce<FieldsContainer<HasFieldDimensions<T>>>(
    (acc, current, index, source) => {
      const begin = acc.end + 1 + (index === 0 ? 0 : delimiterLength);
      const end = begin + Number(source[index]?.length || 0) - 1;
      const newAcc = {
        fields: acc.fields.concat([
          {
            ...current,
            begin,
            end,
          },
        ]),
        end,
      };
      return newAcc;
    },
    {
      fields: [] as HasFieldDimensions<T>[],
      end: 0,
    },
  );
};
